const $win = $(window);
const $doc = $(document);

$win.on('load', function() {
	// Mobile Navigation
	$('.btn-burger').on('click', function(e) {
		e.preventDefault();

		$('.btn-burger')
			.toggleClass('active');

		$('.header')
			.toggleClass('expanded');

		if(!$(this).hasClass('active')) {
            $('.nav .nav__dropdown').slideUp();
        }
	});

	// Megamenu
	$('.nav a').each(function() {
		if ($(this).siblings().length) {
			$(this)
				.parent()
				.addClass('has-dropdown');
		}
	});

	$('.nav > ul > li.has-dropdown > a').on('click', function(e) {
		e.preventDefault();
	});

	$('.nav a').on('click', function(e) {
        if ($(this).siblings('.nav__dropdown').length ) {
            if( $win.width() < 768 ) {
                if(!$(this).siblings().is(':visible')) {
                    e.preventDefault();
                }

                $(this)
                    .next()
                    .slideToggle()
                    .parent()
                    .siblings()
                    .find('.nav__dropdown')
                    .slideUp();
            }
        }
    });

	// Cart
	$doc.on('change', '.js-product-radios input', function() {
		var value = $(this).data('option-0') || '';
		var $form = $(this).closest('form');
		var $select = $form.find('.js-select-variant');
		var $selectProduct = $form.find('.js-select-product select');

		if ($select.length) {
			var selectCurrentOption = $form.find('.js-select-variant option:selected').data('option-1') || '';

			$selectProduct.val($form.find('option[data-option-1="' + value + '"][data-option-2="' + selectCurrentOption + '"]').val());

		} else {
			$selectProduct.val($form.find('option[data-option-1="' + value + '"]').val());
		}

		$(this).closest('.js-price-outer').find('.js-price').text($selectProduct.find('option:selected').data('price'));
	});

	$doc.on('change', '.js-select-variant select', function() {
		var value = $(this).find('option:selected').data('option-1');
		var $form = $(this).closest('form');
		var $radios = $form.find('.js-product-radios');
		var $selectProduct = $form.find('.js-select-product select');

		if ($radios.length) {
			var radioOption = $radios.find('input:checked').data('option-0');

			$selectProduct.val($form.find('option[data-option-1="' + radioOption + '"][data-option-2="' + value + '"]').val());
		} else {
			value = $(this).find('option:selected').data('option-0');

			$selectProduct.val($form.find('option[data-option-1="' + value + '"]').val());
		}

		$(this).closest('.js-price-outer').find('.js-price').text($selectProduct.find('option:selected').data('price'));
	});

	$doc.on('click', '.js-cart-button', function(e) {
		e.preventDefault();
		var $form = $(this).closest('form');

		$(this)
			.closest('.expanded')
			.removeClass('expanded');

		$.ajax({
			url: '/cart/add.js',
			dataType: "json",
			data: $form.serialize(),
			success: function(result) {
				$.ajax({
					url: '/cart',
					success: function(data) {
						var $html = $(data).find('.cart__inner');
						var $total = $(data).find('.cart-global-total span');

						$('.cart .cart__container').html($html);

						$('.cart').addClass('expanded');

						$('.nav-utilities .btn-cart span').html($total);
					}
				})
			}
		});
	});

    // Toggle Button
	$doc.on('click', '.js-btn-toggle', function(e) {
		e.preventDefault();

		var $this = $(this);
	    var $target = $($this.attr('href'));

		if ($this.hasClass('btn-cart')) {
			// Expand Cart
			$.ajax({
				url: '/cart',
				success: function(data) {
		            data=$(data).find('.cart__inner');
				    $('.cart .cart__container').html(data);

					$target
						.toggleClass('expanded');
				}
		    });
		} else if ($this.hasClass('btn-shop')) {
			var href = $this.data('href');
			
			$.ajax({
				url: href,
				success: function(data) {
					var $content = $(data).find('.popup-product-holder .popup__content');

		            $content.find('[name],[for]').each(function() {
		            	var $item = $(this);
		            	var id = $item.attr('name') || $item.attr('for');
		            	var idx = id + '-' + $content.data('id');
		            	var attr = $item.is('label') ? 'for' : 'name';

		            	if ($item.is('select') || $item.filter('[name="quantity"]').length ) {
		            		return;
		            	};

	            		$item.attr(attr, idx);

	            		if (attr == 'name') {
	            			$item.attr('id', $item.attr('id') + '-' + $content.data('id'));
	            		};
		            });

				    $('.popup-outer-collection .popup__container').html($content);

					$('.popup-outer-collection').toggleClass('expanded');
				}
		    });
		} else {
			$target
				.toggleClass('expanded');
		}
	});

	// Quantity
	$doc
		.on('click', '.qty-btn', function(e) {
			e.preventDefault();

			var $this = $(this);
			var qtyInput = $this.parent().find('.qty-field');
			var qtyInputVal = qtyInput.val();
			qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;

			if ($this.hasClass('qty-btn--plus')) {
				qtyInputVal++;
				qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
			} else {
				qtyInputVal--;
				qtyInputVal = qtyInputVal < 0 ? 0 : qtyInputVal;
			}
			qtyInput.val(qtyInputVal);

			$this.closest('.qty-wrapper').addClass('qty-prevent');

			var $serializeForm = $(this).closest('.form').serialize();

			if (!$this.closest('.cart').length) {
				$.ajax({
					url: '/cart/update.js',
					dataType: "json",
					data: $serializeForm,
					success: function(result) {
						$.ajax({
							url: '/cart',
							success: function(data) {
								var $html = $(data).find('.section-cart .section__inner');
								var $total = $(data).find('.cart-global-total span');

								$('.section-cart').html($html);

								$('.nav-utilities .btn-cart span').html($total);

								$('.qty-wrapper').removeClass('qty-prevent');
							}
						})
					}
				});
			} else {
				$.ajax({
					url: '/cart/update.js',
					dataType: "json",
					data: $serializeForm,
					success: function(result) {
						$.ajax({
							url: '/cart',
							success: function(data) {
								var $html = $(data).find('.cart__inner');
								var $total = $(data).find('.cart-global-total span');

								$('.cart .cart__container').html($html);
								
								$('.nav-utilities .btn-cart span').html($total);

								$('.qty-wrapper').removeClass('qty-prevent');
							}
						})
					}
				});
			}
		});

	$doc.on('click', '.js-btn-remove', function(e) {
		e.preventDefault();

		var productId = parseInt($(this).attr('href'));

		$.post('/cart/update.js', 'updates[' + productId + ']=0')
			.done(function() {
				$.ajax({
					url: '/cart',
					success: function(data) {
						var $html = $(data).find('.cart__inner');
						var $total = $(data).find('.cart-global-total span');

						$('.cart .cart__container').html($html);
						
						$('.nav-utilities .btn-cart span').html($total);
					}
				})
			});
	});

	// Accordion Functionality
	$('.accordion .accordion__head').on('click', function() {
		$(this)
			.next()
			.slideToggle()
			.parent()
			.addClass('expanded')
			.siblings()
			.removeClass('expanded')
			.find('.accordion__body')
			.slideUp();
	});

	// Tabs Functionality
	var activeTabClass = 'current';
    $('.tabs__nav a').on('click', function(e) {
        e.preventDefault();

        var $tabLink = $(this);
        var $targetTab = $($tabLink.attr('href'));
 
        $tabLink
            .parent()
            .add($targetTab)
            .addClass(activeTabClass)
                .siblings()
                .removeClass(activeTabClass);
    });

    // Search Functionality
    $('.search input[placeholder]').each(function () {
        $(this).attr('size', $(this).attr('placeholder').length);

        $('.search input').css('width', $(this).width())
    });

    $('.search input:not([type="submit"])')
		.on('focusin', function() {
			$(this)
				.closest('.search')
					.addClass('alt');
		})
		.on('focusout', function() {
			if (this.value === '') {
				$(this)
					.closest('.search')
						.removeClass('alt');
			}
		});

	// Login Radios
	$('.js-radios-form input').on('change', function() {
		var id = $(this).attr('id');

		$('[data-form-group="' + id + '"]')
			.addClass('current')
			.siblings()
			.removeClass('current');
	});

	// Article Images
	$('.article .article-entry img').each(function(e) {
		var $image = $(this);
		var alt = $image.attr('alt');
		$image.wrap('<span class="article-image-outer"></span>');

		if (alt) {
			$image.parent('.article-image-outer').append('<small>' + alt + '</small>');
		}
	});

	var isMacLike = navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i)?true:false;

	if (isMacLike) {
		if ($('.article .article-actions').length) {
			$('.article .article-actions').addClass('article-actions--mac');
		}
	}
});




// WEBPACK FOOTER //
// ./../src/assets/js/main.js